import PropTypes from 'prop-types';
import React from 'react';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import ListItem from '../ListItem';

import './CurrencyItem.scss';

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const CurrencyItem = ({ className = '', currency, lastItem = false, onClick = () => {} }) => {
	const currencyData = CurrenciesById[currency.Id];
	const currencyBlockchainData = BlockchainsById[currencyData.BlockchainId];

	const onSelect = () => onClick(currency);

	return (
		<ListItem
			className={'CurrencyItem ' + className}
			icon={currencyData.CompanyIcon}
			iconLabel={currencyData.CompanyIcon !== currencyBlockchainData.Icon ? currencyBlockchainData.Icon : null}
			title={currencyData.Name}
			label={currencyBlockchainData.Name}
			description={currencyData.Company}
			rightTitle={HelperService.FormatCrypto(currency.Amount, currencyData.Precision)}
			rightDescription={'$' + HelperService.FormatFiatWithoutCurrency(currency.AmountUsd)}
			onSelect={onSelect}
			bottomSeparator={!lastItem}
		/>
	);
};

CurrencyItem.propTypes = {
	className: PropTypes.string,
	currency: PropTypes.object,
	lastItem: PropTypes.bool,
	onClick: PropTypes.func,
};

export default CurrencyItem;
